import styled from "@emotion/styled";
import { fontRobotoCondensed } from "@product/scmp-sdk";

import { EntityLink } from "scmp-app/components/entity-link";

export const Container = styled.div`
  display: flex;
  flex-flow: column;
  gap: 20px;
  justify-content: center;
  align-items: flex-start;

  padding-block: 20px;
  padding-inline: 16px;

  color: #666666;
  line-height: 19px;

  border-radius: 5px;

  background: #f2f2f2;
`;

export const Label = styled.div`
  color: #000000;
  font-weight: 900;
  font-size: 16px;
`;

export const TopicLink = styled(EntityLink)`
  color: #666666;
  font-size: 16px;
  font-family: ${fontRobotoCondensed};

  &:hover {
    color: #2c4692;
  }
`;
